import React from 'react';
import { useTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Grid, Icon, Theme, Typography } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { lastUpdatedInfoModel } from '../../api-refactored/exam-configuration/useGetLastUpdatedInfo';
import { fallbackDashString } from '../../utils/StringUtils';
import { stringToLongDateAndShortTime } from '../../utils/DateUtils';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  container: {
    marginTop: theme.spacing(6),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  message: {
    fontWeight: 800,
    color: theme.color.text.textSecondary,
  },
}));

interface DraftTimeStampProps {
  lastUpdatedInfo: lastUpdatedInfoModel;
}

const DraftDateTimeStamp = ({ lastUpdatedInfo }: DraftTimeStampProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles();

  const { name, lastUpdatedTime } = lastUpdatedInfo;

  const lastUpdatedDateTime = fallbackDashString(lastUpdatedTime);

  return (
    (<Grid
      xs={12}
      className={classes.container}
      direction="row"
      wrap="nowrap"
      container
      alignItems="center"
      justify="flex-start"
    >
      <Icon
        size="M"
        name={IconName.alertOff}
        className={classes.icon}
        color={theme.color.icon.iconSelected}
      />
      <Typography className={classes.message} variant="subtitle2">
        {t('components->>DraftTimeStamp.LastUpdated', {
          userName: fallbackDashString(name),
          dateTime:
            lastUpdatedDateTime === '-'
              ? lastUpdatedDateTime
              : stringToLongDateAndShortTime(lastUpdatedDateTime),
        })}
      </Typography>
    </Grid>)
  );
};

export default DraftDateTimeStamp;
